import { render, staticRenderFns } from "./NotificationsColumns.vue?vue&type=template&id=39c2cb2d&"
import script from "./NotificationsColumns.vue?vue&type=script&lang=js&"
export * from "./NotificationsColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports